import React, { useState } from 'react';
import { Eye, EyeOff } from 'react-feather';
import { IconButton } from '@material-ui/core';

import InputField, { InputProps } from 'components/InputField';
import GATracking, { EVENT_ACTION } from 'helpers/GATracking';

const PasswordInputField = (props: InputProps) => {
  const {
    placeholder,
    name,
    value,
    error,
    helperText,
    handleChange,
    handleBlur,
    label,
    startAdornment,
    gAEventCategory,
  } = props;
  const [isShowPassword, setIsShowPassword] = useState(false);
  return (
    <InputField
      type={isShowPassword ? 'text' : 'password'}
      endAdornment={
        <IconButton
          aria-label="toggle-password-visibility"
          onClick={() => {
            if (props.gAEventCategory) {
              GATracking.event(
                gAEventCategory,
                EVENT_ACTION.CLICK,
                'Voir le mot de passe',
              );
            }
            setIsShowPassword(!isShowPassword);
          }}
        >
          {isShowPassword ? <Eye /> : <EyeOff />}
        </IconButton>
      }
      placeholder={placeholder}
      name={name}
      value={value}
      error={error}
      helperText={helperText}
      handleChange={handleChange}
      handleBlur={handleBlur}
      label={label}
      startAdornment={startAdornment}
    />
  );
};

export default PasswordInputField;
